// ******************************************************
// ******************************************************
// ******************************************************
// *****    Definition of the Audio.
// *****    This code is generated. Do not edit manaully.
// ******************************************************
// ******************************************************
// ******************************************************
import { tbAudioSprite } from "../../engine/tbAudioSprite";
import { tbSound } from "../../engine/tbSound";
export var balloon_pop_small;
export var bar_swoosh_in;
export var bar_swoosh_out;
export var black_select;
export var black_voice_idle_2;
export var black_voice_impact_3;
export var black_voice_release_2;
export var black_voice_stretch_3;
export var blue_select;
export var blue_split;
export var blue_voice_death;
export var blue_voice_idle;
export var blue_voice_impact_3;
export var blue_voice_release_2;
export var blue_voice_split;
export var blue_voice_stretch_2;
export var bomb_buildup;
export var egg_drop;
export var iceshower_afterspawn;
export var iceshower_select;
export var iceshower_spawn;
export var ice_damaged_3;
export var ice_destroyed_2;
export var ice_impact_medium_2;
export var matilda_select;
export var matilda_voice_death_2;
export var matilda_voice_eggdrop_3;
export var matilda_voice_idle_3;
export var matilda_voice_impact;
export var matilda_voice_release_4;
export var matilda_voice_stretch;
export var minion_pig_death;
export var minion_pig_flying_death_3;
export var minion_pig_giggle_long_2;
export var minion_pig_hurt_2;
export var minion_pig_idle;
export var minion_pig_laugh_3;
export var minion_pig_scared;
export var minion_pig_snore_exhale_2;
export var minion_pig_snore_inhale_2;
export var pigshield_afterspawn;
export var pigshield_select;
export var pigshield_spawn;
export var red_select;
export var red_shockwave;
export var red_voice_death_2;
export var red_voice_idle_3;
export var red_voice_impact_2;
export var red_voice_release_2;
export var red_voice_shockwave;
export var red_voice_stretch;
export var rock_damaged_3;
export var rock_destroyed_3;
export var rock_impact_medium;
export var sfx_generalbutton;
export var slingshot_fire;
export var slingshot_stretch_soft;
export var stonenator_spawn;
export var swappigs_spawn;
export var terence_select;
export var terence_voice_death_2;
export var terence_voice_impact_2;
export var terence_voice_release;
export var terence_voice_stretch_2;
export var tnt_explosion;
export var tnt_select;
export var tnt_spawn;
export var wood_damaged_3;
export var wood_destroyed;
export var wood_impact_medium_2;
export var yellow_boost;
export var yellow_select;
export var yellow_voice_boost;
export var yellow_voice_death_2;
export var yellow_voice_idle;
export var yellow_voice_impact_2;
export var yellow_voice_release_3;
export var yellow_voice_stretch_2;
export var a_ghostbar_fill;
export var a_progressbar_fill;
export var feather_glimmer_loop;
export var stars_level_up;
export var amb_cobaltplateau;
export var a_music;
export var mus_ingame;
export var mus_lobby;
export var mus_stinger_lose;
export var mus_stinger_win;
export var ui_back;
export var ui_entergame;
export var ui_explosion;
export var ui_replaytv_explosion;
export var ui_select;
export var audioSpriteEffects;
export var audioSpriteExp;
export var audioSpriteSound;
export var audioSpriteUi;
export var initializeAudio = function () {
    audioSpriteEffects = new tbAudioSprite("audioSpriteEffects", "audio/audioSpriteEffects.mp3", "audio/audioSpriteEffects.ogg", "audio");
    audioSpriteExp = new tbAudioSprite("audioSpriteExp", "audio/audioSpriteExp.mp3", "audio/audioSpriteExp.ogg", "audio");
    audioSpriteSound = new tbAudioSprite("audioSpriteSound", "audio/audioSpriteSound.mp3", "audio/audioSpriteSound.ogg", "audio");
    audioSpriteUi = new tbAudioSprite("audioSpriteUi", "audio/audioSpriteUi.mp3", "audio/audioSpriteUi.ogg", "audio");
    balloon_pop_small = new tbSound("balloon_pop_small", audioSpriteEffects, 0, 330.3628117913832, 50 / 100, 10, ["game"]);
    bar_swoosh_in = new tbSound("bar_swoosh_in", audioSpriteEffects, 2000, 604.172335600907, 50 / 100, 10, ["game"]);
    bar_swoosh_out = new tbSound("bar_swoosh_out", audioSpriteEffects, 4000, 562.49433106576, 50 / 100, 10, ["game"]);
    black_select = new tbSound("black_select", audioSpriteEffects, 6000, 1259.0929705215422, 50 / 100, 10, ["game"]);
    black_voice_idle_2 = new tbSound("black_voice_idle_2", audioSpriteEffects, 9000, 2194.625850340137, 50 / 100, 10, ["game"]);
    black_voice_impact_3 = new tbSound("black_voice_impact_3", audioSpriteEffects, 13000, 585.6462585034005, 50 / 100, 10, ["game"]);
    black_voice_release_2 = new tbSound("black_voice_release_2", audioSpriteEffects, 15000, 920.0680272108839, 50 / 100, 10, ["game"]);
    black_voice_stretch_3 = new tbSound("black_voice_stretch_3", audioSpriteEffects, 17000, 599.6825396825407, 50 / 100, 10, ["game"]);
    blue_select = new tbSound("blue_select", audioSpriteEffects, 19000, 1042.380952380954, 50 / 100, 10, ["game"]);
    blue_split = new tbSound("blue_split", audioSpriteEffects, 22000, 325.2607709750555, 50 / 100, 10, ["game"]);
    blue_voice_death = new tbSound("blue_voice_death", audioSpriteEffects, 24000, 209.16099773242604, 50 / 100, 10, ["game"]);
    blue_voice_idle = new tbSound("blue_voice_idle", audioSpriteEffects, 26000, 928.6167800453513, 50 / 100, 10, ["game"]);
    blue_voice_impact_3 = new tbSound("blue_voice_impact_3", audioSpriteEffects, 28000, 205.10204081632764, 50 / 100, 10, ["game"]);
    blue_voice_release_2 = new tbSound("blue_voice_release_2", audioSpriteEffects, 30000, 1360.1587301587315, 50 / 100, 10, ["game"]);
    blue_voice_split = new tbSound("blue_voice_split", audioSpriteEffects, 33000, 1358.0952380952367, 50 / 100, 10, ["game"]);
    blue_voice_stretch_2 = new tbSound("blue_voice_stretch_2", audioSpriteEffects, 36000, 790.2947845804956, 50 / 100, 10, ["game"]);
    bomb_buildup = new tbSound("bomb_buildup", audioSpriteEffects, 38000, 1656.9614512471599, 50 / 100, 10, ["game"]);
    egg_drop = new tbSound("egg_drop", audioSpriteEffects, 41000, 555.1700680272115, 50 / 100, 10, ["game"]);
    iceshower_afterspawn = new tbSound("iceshower_afterspawn", audioSpriteEffects, 43000, 5000, 50 / 100, 10, ["game"]);
    iceshower_select = new tbSound("iceshower_select", audioSpriteEffects, 49000, 1750, 50 / 100, 10, ["game"]);
    iceshower_spawn = new tbSound("iceshower_spawn", audioSpriteEffects, 52000, 1566.4625850340162, 50 / 100, 10, ["game"]);
    ice_damaged_3 = new tbSound("ice_damaged_3", audioSpriteEffects, 55000, 802.1768707482988, 50 / 100, 10, ["game"]);
    ice_destroyed_2 = new tbSound("ice_destroyed_2", audioSpriteEffects, 57000, 854.9433106575962, 50 / 100, 10, ["game"]);
    ice_impact_medium_2 = new tbSound("ice_impact_medium_2", audioSpriteEffects, 59000, 433.3333333333285, 50 / 100, 10, ["game"]);
    matilda_select = new tbSound("matilda_select", audioSpriteEffects, 61000, 912.2675736961464, 50 / 100, 10, ["game"]);
    matilda_voice_death_2 = new tbSound("matilda_voice_death_2", audioSpriteEffects, 63000, 453.06122448979295, 50 / 100, 10, ["game"]);
    matilda_voice_eggdrop_3 = new tbSound("matilda_voice_eggdrop_3", audioSpriteEffects, 65000, 434.9886621315163, 50 / 100, 10, ["game"]);
    matilda_voice_idle_3 = new tbSound("matilda_voice_idle_3", audioSpriteEffects, 67000, 817.5510204081656, 50 / 100, 10, ["game"]);
    matilda_voice_impact = new tbSound("matilda_voice_impact", audioSpriteEffects, 69000, 264.44444444445253, 50 / 100, 10, ["game"]);
    matilda_voice_release_4 = new tbSound("matilda_voice_release_4", audioSpriteEffects, 71000, 1138.3900226757396, 50 / 100, 10, ["game"]);
    matilda_voice_stretch = new tbSound("matilda_voice_stretch", audioSpriteEffects, 74000, 6288.39002267574, 50 / 100, 10, ["game"]);
    minion_pig_death = new tbSound("minion_pig_death", audioSpriteEffects, 82000, 481.2925170068047, 50 / 100, 10, ["game"]);
    minion_pig_flying_death_3 = new tbSound("minion_pig_flying_death_3", audioSpriteEffects, 84000, 1887.8911564625887, 50 / 100, 10, ["game"]);
    minion_pig_giggle_long_2 = new tbSound("minion_pig_giggle_long_2", audioSpriteEffects, 87000, 1278.5714285714203, 50 / 100, 10, ["game"]);
    minion_pig_hurt_2 = new tbSound("minion_pig_hurt_2", audioSpriteEffects, 90000, 448.50340136053273, 50 / 100, 10, ["game"]);
    minion_pig_idle = new tbSound("minion_pig_idle", audioSpriteEffects, 92000, 640.7936507936538, 50 / 100, 10, ["game"]);
    minion_pig_laugh_3 = new tbSound("minion_pig_laugh_3", audioSpriteEffects, 94000, 1863.5600907029439, 50 / 100, 10, ["game"]);
    minion_pig_scared = new tbSound("minion_pig_scared", audioSpriteEffects, 97000, 864.172335600917, 50 / 100, 10, ["game"]);
    minion_pig_snore_exhale_2 = new tbSound("minion_pig_snore_exhale_2", audioSpriteEffects, 99000, 800.0226757369528, 50 / 100, 10, ["game"]);
    minion_pig_snore_inhale_2 = new tbSound("minion_pig_snore_inhale_2", audioSpriteEffects, 101000, 800, 50 / 100, 10, ["game"]);
    pigshield_afterspawn = new tbSound("pigshield_afterspawn", audioSpriteEffects, 103000, 1533.3333333333285, 50 / 100, 10, ["game"]);
    pigshield_select = new tbSound("pigshield_select", audioSpriteEffects, 106000, 966.6666666666715, 50 / 100, 10, ["game"]);
    pigshield_spawn = new tbSound("pigshield_spawn", audioSpriteEffects, 108000, 2100, 50 / 100, 10, ["game"]);
    red_select = new tbSound("red_select", audioSpriteEffects, 112000, 789.4784580498817, 50 / 100, 10, ["game"]);
    red_shockwave = new tbSound("red_shockwave", audioSpriteEffects, 114000, 1366.666666666657, 50 / 100, 10, ["game"]);
    red_voice_death_2 = new tbSound("red_voice_death_2", audioSpriteEffects, 117000, 358.820861678003, 50 / 100, 10, ["game"]);
    red_voice_idle_3 = new tbSound("red_voice_idle_3", audioSpriteEffects, 119000, 1089.6825396825443, 50 / 100, 10, ["game"]);
    red_voice_impact_2 = new tbSound("red_voice_impact_2", audioSpriteEffects, 122000, 285.05668934239657, 50 / 100, 10, ["game"]);
    red_voice_release_2 = new tbSound("red_voice_release_2", audioSpriteEffects, 124000, 1252.3129251700739, 50 / 100, 10, ["game"]);
    red_voice_shockwave = new tbSound("red_voice_shockwave", audioSpriteEffects, 127000, 478.2993197278993, 50 / 100, 10, ["game"]);
    red_voice_stretch = new tbSound("red_voice_stretch", audioSpriteEffects, 129000, 1148.117913832204, 50 / 100, 10, ["game"]);
    rock_damaged_3 = new tbSound("rock_damaged_3", audioSpriteEffects, 132000, 925.6689342403552, 50 / 100, 10, ["game"]);
    rock_destroyed_3 = new tbSound("rock_destroyed_3", audioSpriteEffects, 134000, 1304.444444444438, 50 / 100, 10, ["game"]);
    rock_impact_medium = new tbSound("rock_impact_medium", audioSpriteEffects, 137000, 433.1746031745861, 50 / 100, 10, ["game"]);
    sfx_generalbutton = new tbSound("sfx_generalbutton", audioSpriteEffects, 139000, 771.5873015872785, 50 / 100, 10, ["game"]);
    slingshot_fire = new tbSound("slingshot_fire", audioSpriteEffects, 141000, 1375.3287981859467, 50 / 100, 10, ["game"]);
    slingshot_stretch_soft = new tbSound("slingshot_stretch_soft", audioSpriteEffects, 144000, 4298.730158730177, 50 / 100, 10, ["game"]);
    stonenator_spawn = new tbSound("stonenator_spawn", audioSpriteEffects, 150000, 1626.3038548752957, 50 / 100, 10, ["game"]);
    swappigs_spawn = new tbSound("swappigs_spawn", audioSpriteEffects, 153000, 2702.8117913832248, 50 / 100, 10, ["game"]);
    terence_select = new tbSound("terence_select", audioSpriteEffects, 157000, 1556.122448979586, 50 / 100, 10, ["game"]);
    terence_voice_death_2 = new tbSound("terence_voice_death_2", audioSpriteEffects, 160000, 823.7188208616572, 50 / 100, 10, ["game"]);
    terence_voice_impact_2 = new tbSound("terence_voice_impact_2", audioSpriteEffects, 162000, 724.2857142857101, 50 / 100, 10, ["game"]);
    terence_voice_release = new tbSound("terence_voice_release", audioSpriteEffects, 164000, 4033.219954648521, 50 / 100, 10, ["game"]);
    terence_voice_stretch_2 = new tbSound("terence_voice_stretch_2", audioSpriteEffects, 170000, 3316.666666666657, 50 / 100, 10, ["game"]);
    tnt_explosion = new tbSound("tnt_explosion", audioSpriteEffects, 175000, 1769.591836734704, 50 / 100, 10, ["game"]);
    tnt_select = new tbSound("tnt_select", audioSpriteEffects, 178000, 1064.580498866213, 50 / 100, 10, ["game"]);
    tnt_spawn = new tbSound("tnt_spawn", audioSpriteEffects, 181000, 2041.8594104308577, 50 / 100, 10, ["game"]);
    wood_damaged_3 = new tbSound("wood_damaged_3", audioSpriteEffects, 185000, 667.6870748299407, 50 / 100, 10, ["game"]);
    wood_destroyed = new tbSound("wood_destroyed", audioSpriteEffects, 187000, 673.4013605442015, 50 / 100, 10, ["game"]);
    wood_impact_medium_2 = new tbSound("wood_impact_medium_2", audioSpriteEffects, 189000, 251.2698412698519, 50 / 100, 10, ["game"]);
    yellow_boost = new tbSound("yellow_boost", audioSpriteEffects, 191000, 1823.2653061224264, 50 / 100, 10, ["game"]);
    yellow_select = new tbSound("yellow_select", audioSpriteEffects, 194000, 933.333333333343, 50 / 100, 10, ["game"]);
    yellow_voice_boost = new tbSound("yellow_voice_boost", audioSpriteEffects, 196000, 2053.333333333343, 50 / 100, 10, ["game"]);
    yellow_voice_death_2 = new tbSound("yellow_voice_death_2", audioSpriteEffects, 200000, 261.3151927437575, 50 / 100, 10, ["game"]);
    yellow_voice_idle = new tbSound("yellow_voice_idle", audioSpriteEffects, 202000, 393.69614512473345, 50 / 100, 10, ["game"]);
    yellow_voice_impact_2 = new tbSound("yellow_voice_impact_2", audioSpriteEffects, 204000, 266.59863945579855, 50 / 100, 10, ["game"]);
    yellow_voice_release_3 = new tbSound("yellow_voice_release_3", audioSpriteEffects, 206000, 3094.2403628118045, 50 / 100, 10, ["game"]);
    yellow_voice_stretch_2 = new tbSound("yellow_voice_stretch_2", audioSpriteEffects, 211000, 1202.8798185941123, 50 / 100, 10, ["game"]);
    a_ghostbar_fill = new tbSound("a_ghostbar_fill", audioSpriteExp, 0, 79.9092970521542, 50 / 100, 10, ["game"]);
    a_progressbar_fill = new tbSound("a_progressbar_fill", audioSpriteExp, 2000, 150.47619047619082, 50 / 100, 10, ["game"]);
    feather_glimmer_loop = new tbSound("feather_glimmer_loop", audioSpriteExp, 4000, 4875.01133786848, 50 / 100, 10, ["game"]);
    stars_level_up = new tbSound("stars_level_up", audioSpriteExp, 10000, 3875.01133786848, 50 / 100, 10, ["game"]);
    amb_cobaltplateau = new tbSound("amb_cobaltplateau", audioSpriteSound, 0, 30000, 75 / 100, 10, ["music", "ambience"]);
    a_music = new tbSound("a_music", audioSpriteSound, 31000, 12044.399092970525, 75 / 100, 10, ["music"]);
    mus_ingame = new tbSound("mus_ingame", audioSpriteSound, 45000, 43459.070294784586, 75 / 100, 10, ["music"]);
    mus_lobby = new tbSound("mus_lobby", audioSpriteSound, 90000, 33750, 75 / 100, 10, ["music"]);
    mus_stinger_lose = new tbSound("mus_stinger_lose", audioSpriteSound, 125000, 3686.1678004535206, 75 / 100, 10, ["music"]);
    mus_stinger_win = new tbSound("mus_stinger_win", audioSpriteSound, 130000, 6047.14285714287, 75 / 100, 10, ["music"]);
    ui_back = new tbSound("ui_back", audioSpriteUi, 0, 122.65306122448979, 50 / 100, 10, ["game"]);
    ui_entergame = new tbSound("ui_entergame", audioSpriteUi, 2000, 1277.3469387755104, 50 / 100, 10, ["game"]);
    ui_explosion = new tbSound("ui_explosion", audioSpriteUi, 5000, 1310.022675736962, 50 / 100, 10, ["game"]);
    ui_replaytv_explosion = new tbSound("ui_replaytv_explosion", audioSpriteUi, 8000, 3024.648526077097, 50 / 100, 10, ["game"]);
    ui_select = new tbSound("ui_select", audioSpriteUi, 13000, 156.23582766439904, 50 / 100, 10, ["game"]);
};
